module.exports = __webpack_public_path__ + "static/media/selected_cave_marker.64c9544f.svg";